import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Hero from '../../components/Hero/Hero';
import Clients from '../../components/Clients/Clients';
import Feature from '../../components/Feature/Feature';
import Industries from '../../components/Industries/Industries';
import GetStarted from '../../components/GetStarted/GetStarted';
import Contact from '../../components/Contact/Contact';
import Footer from '../../components/Footer/Footer';
import './LandingPage.css';

function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace('#', ''); 
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);
 
  
  return (
    <div style={{ overflow: 'hidden' }}>
      <Navbar />
      <Hero />
      <Clients />
      <Feature />
      <Industries />
      <GetStarted />
      <Contact />
      <Footer />
    </div>
  );
}

export default LandingPage;
